import React from "react";
import { getIconForUID } from "components/FormerEditor/utils";
import GridCell from "components/GridCell";
import { NO_OP } from "utils/action";

const UnauthedPickerPrompt = ({
  icon,
  header,
  subheader,
  children,
  onClick = NO_OP
}) => {
  const Icon = getIconForUID(icon);

  return (
    <GridCell
      onClick={onClick}
      Icon={Icon}
      customClasses={{
        container: "flex flex-column w-100 ba br2 pa3 hairline-1 relative mb2"
      }}
      hideHover
      label={header}
      description={subheader}
    >
      {children}
    </GridCell>
  );
};

export default UnauthedPickerPrompt;
